import {
  Box,
  Typography,
  Paper,
  Chip,
  chipClasses,
  Button,
  TextField,
  IconButton,
  Stack,
  Tooltip,
  Grid,
} from "@mui/material";
// import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useEffect, useMemo, useState } from "react";
import FormControl from "@mui/material/FormControl";
// import { ReportsData } from './ecd-reports-database';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { ToolBar } from "../../../components/toolbar";
import dayjs from "dayjs";
import { SelectA } from "../../../components/form";
import CircularProgress from "@mui/material/CircularProgress";
import { CONFIG } from "../../../../config";
import { useSelector, useDispatch } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";

import axios from "axios";
import { isNull } from "lodash";
import PopoverSearch from "../../../components/PopoverSearch";
import toast from "react-hot-toast";
const API_HOST_CRM = CONFIG.modules["crm"].host;

const QualityAssurance = () => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});

  const [agent, setAgent] = useState();
  const [currentDate] = useState(new Date());
  const [loader, setLoader] = useState();
  const [filter, setFilter] = useState({
    from: dayjs(), // dayjs("01-01-2023"),
    to: dayjs(),
  });

  // don't show the other data till quality assurance is fetch
  const [isQAExists, setIsQAExists] = useState(false);
  const [qaFromBackend, setQAFromBackend] = useState(null);

  const [callReqObj, setCallReqObj] = useState({
    user_name: "nhm_meghalaya",
    api_key: "KK6530499e65627bd1f85eb8d669b52cf9",
    // from_date: currentDate?.getFullYear() + '-0' + (currentDate?.getMonth() + 1) + '-' + currentDate?.getDate() + ' ' + currentDate?.getHours() + ':' + currentDate?.getMinutes() + ':' + currentDate?.getSeconds(),
    // to_date: currentDate?.getFullYear() + '-0' + (currentDate?.getMonth() + 1) + '-' + (currentDate?.getDate() + 1) + ' ' + currentDate?.getHours() + ':' + currentDate?.getMinutes() + ':' + currentDate?.getSeconds(),
    from_date:
      currentDate &&
      currentDate?.getFullYear() +
        "-" +
        (currentDate?.getMonth() < 10
          ? "0" + (currentDate?.getMonth() + 1)
          : currentDate?.getMonth()) +
        "-" +
        (currentDate?.getDate() < 10
          ? "0" + (currentDate?.getDate() - 1)
          : currentDate?.getDate() - 1) +
        " " +
        (currentDate?.getHours() < 10
          ? "0" + currentDate?.getHours()
          : currentDate?.getHours()) +
        ":" +
        (currentDate?.getMinutes() < 10
          ? "0" + currentDate?.getMinutes()
          : currentDate?.getMinutes()) +
        ":" +
        (currentDate?.getSeconds() < 10
          ? "0" + currentDate?.getSeconds()
          : currentDate?.getSeconds()),
    to_date:
      currentDate &&
      currentDate?.getFullYear() +
        "-" +
        (currentDate?.getMonth() < 10
          ? "0" + (currentDate?.getMonth() + 1)
          : currentDate?.getMonth()) +
        "-" +
        (currentDate?.getDate() < 10
          ? "0" + currentDate?.getDate()
          : currentDate?.getDate()) +
        " " +
        (currentDate?.getHours() < 10
          ? "0" + currentDate?.getHours()
          : currentDate?.getHours()) +
        ":" +
        (currentDate?.getMinutes() < 10
          ? "0" + currentDate?.getMinutes()
          : currentDate?.getMinutes()) +
        ":" +
        (currentDate?.getSeconds() < 10
          ? "0" + currentDate?.getSeconds()
          : currentDate?.getSeconds()),
    campaign_name: "",
    format: "json",
  });
  const [callData, setCallData] = useState();
  const [formValue, setFormValue] = useState({
    CallOpening: 0,
    CallClosing: 0,
    Tone: 0,
    Clarity: 0,
    ActiveListening: 0,
    ProcessKnowledge: 0,
    DataIntegrity: 0,
    redFlags: "",
    FeedbackToCaller: "",
  });

  const [callList, setCallList] = useState([]);
  const [callRecording, setCallRecording] = useState(null);
  const [caseData, setCaseData] = useState(isNull);

  // state for selected telecaller
  const [selectedTelecaller, setSelectedTelecaller] = useState(null);

  // state for ozonetell agent data
  const [dataFromOzone, setDataFromOzone] = useState(null);

  // this will passed down to popoverSearch
  const selectTelecallerHandler = (value) => {
    setSelectedTelecaller(value);
    return value;
  };

  const getQualityAssuranceByUCID = () => {
    if (!dataFromOzone) return;
    axios
      .get(API_HOST_CRM + `/quality-assurance?ucid=${dataFromOzone["UCID"]}`)
      .then((resp) => {
        if (resp.data.qa.length > 0) {
          console.log(resp.data, "qa from backend");
          setIsQAExists(true);
          setQAFromBackend(resp.data.qa[0]);
        } else {
          setIsQAExists(false);
          setQAFromBackend(null);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getQualityAssuranceByUCID();
  }, [dataFromOzone]);

  const scoreCalculate = useMemo(() => {
    let newvalue =
      formValue?.CallOpening +
      formValue?.CallClosing +
      formValue.Tone +
      formValue.Clarity +
      formValue.ActiveListening +
      formValue.ProcessKnowledge +
      formValue.DataIntegrity;

    // if (qaFromBackend) {
    //   console.log(qaFromBackend);
    //   newvalue =
    //     qaFromBackend.callOpening +
    //     qaFromBackend.callClosing +
    //     qaFromBackend.tone +
    //     qaFromBackend.clarity +
    //     qaFromBackend.activeListening +
    //     qaFromBackend.processKnowledge +
    //     qaFromBackend.dataIntegrity;
    // }

    console.log((newvalue / 5).toFixed(2), formValue, "newvalue");
    return (newvalue / 5).toFixed(2);
    // newvlaue will be the score i.e Math.round(newvalue / 7)
  }, [formValue, dataFromOzone, qaFromBackend]);

  useEffect(() => {
    if (qaFromBackend) {
      setFormValue({
        CallOpening: qaFromBackend.callOpening,
        CallClosing: qaFromBackend.callClosing,
        Tone: qaFromBackend.tone,
        Clarity: qaFromBackend.clarity,
        ActiveListening: qaFromBackend.activeListening,
        ProcessKnowledge: qaFromBackend.processKnowledge,
        DataIntegrity: qaFromBackend.dataIntegrity,
        redFlags: qaFromBackend.redFlags,
        FeedbackToCaller: qaFromBackend.feedbackToCaller,
      });
    }
  }, [dataFromOzone, qaFromBackend]);

  useEffect(() => {}, [agent]);

  const handleSidebar = (data) => {
    // need to change dataFromOzone to null
    // everytime another call data is clicked
    setDataFromOzone(null);

    setCallRecording(null);

    // also need to refresh the formvalues to 0 scores
    setFormValue({
      CallOpening: 0,
      CallClosing: 0,
      Tone: 0,
      Clarity: 0,
      ActiveListening: 0,
      ProcessKnowledge: 0,
      DataIntegrity: 0,
      redFlags: "",
      FeedbackToCaller: "",
    });

    console.log("go get the data from sidebar click", data);
    // console.log(agent?.ucid)
    // some data don't have ucid
    // refactored to it so that only data with ucid is fetched
    // and set the dataFromOzone is set to null
    // to hide the submit button
    if (data && data.ucid) {
      const options = {
        method: "GET",
        headers: { accept: "application/json" },
        params: new URLSearchParams({
          action: "Login",
          apiKey: "KK6530499e65627bd1f85eb8d669b52cf9",
          userName: "nhm_meghalaya",
          phoneNumber: "9127067064",
        }),
      };
      fetch(
        `https://in1-ccaas-api.ozonetel.com/CAServices/CDR/fetchCdrByUCID.php?reportType=${"historical"}&userName=${
          callReqObj?.user_name
        }&apiKey=${callReqObj?.api_key}&ucid=${data.ucid}`,
        options
      )
        // fetch(
        //   `https://in1-ccaas-api.ozonetel.com/CAServices/CDR/fetchCdrByUCID.php?reportType=historical&userName=nhm_meghalaya&apiKey=KK6530499e65627bd1f85eb8d669b52cf9&ucid=9272172293905511`,
        //   options
        // )
        .then((response) => response.json())
        .then((response) => {
          // even when the response status is success,
          // the message might be
          // "No Data Found with UCID <UCID>"
          // so we need to check for that
          if (response.status == "success") {
            if (response.message == `No Data Found with UCID ${data.ucid}`) {
              if (data.audioLink) {
                setDataFromOzone({
                  UCID: data.ucid,
                  "Caller Id": data.callerID,
                  "Campaign Name": data.did,
                  UUI: data._id.toString(),
                  CDR: data.callDetails,
                });
                setCallRecording({
                  "Audio Download": data.audioLink,
                  UCID: data.ucid,
                  Duration:
                    data.callStartTime && data.callEndTime
                      ? dayjs
                          .duration(
                            dayjs(data.callEndTime).diff(
                              dayjs(data.callStartTime)
                            )
                          )
                          .format("HH:mm:ss")
                      : "00:00:00",
                });
              } else {
                setDataFromOzone(null);
              }
            } else {
              setDataFromOzone(response.message[0]);
              setCallRecording(response.message[0]);
            }

            // enabling the submit and the telecaller search popover
            // setDataFromOzone(response.message[0]);
          } else {
            setDataFromOzone(null);
          }
          console.log(response, "new data ozone ozone for call data", data);

          // console.log(Object.groupBy(response.message, ({ AgentName }) => AgentName), 'newagentnow')
          // setCallData(response.message)
          // console.log(Array.isArray(refsponse.message), 'israyy');
          // if (Array.isArray(response.message)) {
          //     setCallData(Object.groupBy(response.message, ({ AgentName }) => AgentName))
          // }
          // setLoader(false)
        })
        .catch((err) => console.error(err));
    } else {
      setDataFromOzone(null);
    }
    setAgent(map?.users?.[data.allocatedToUser]);
    setCaseData(data);
  };

  const handleChangeCall = (e) => {
    console.log(e.target, "for handle call data");
  };

  const fetchCallRecording = () => {
    axios
      .get(
        API_HOST_CRM +
          `/cases?limit=${1000}` +
          `&page=${0}&type=${"attempted"}&withUcid=true&withAudio=true` +
          `${
            filter.from
              ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
              : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
          `${
            filter.status
              ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}`
              : ""
          }` +
          `${
            filter.district
              ? `&district=${encodeURIComponent(
                  JSON.stringify(filter.district)
                )}`
              : ""
          }` +
          `${filter.motherId ? `&motherId=${filter.motherId}` : ""}` +
          `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
          `${filter.contact ? `&contact=${filter.contact}` : ""}` +
          `${
            filter.motherStatus ? `&motherStatus=${filter.motherStatus}` : ""
          }` +
          `${
            filter.telecaller
              ? `&telecaller=${encodeURIComponent(
                  JSON.stringify(filter.telecaller)
                )}`
              : ""
          }` +
          `${
            filter.firstReceived ? `&firstReceived=${filter.firstReceived}` : ""
          }` +
          `${
            filter.cfrom
              ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
              : ""
          }` +
          `${
            filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}` +
          `${filter.priority ? `&priority=${filter.priority}` : ""}`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setCallData(
            Object.groupBy(
              resp.data.cases,
              ({ allocatedToUser }) => allocatedToUser
            )
          );
          setCallList(resp.data.cases);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // const fetchCallRecording = () => {
  //     console.log(callReqObj && callReqObj, 'callReqObj');
  //     setLoader(true)
  //     const options = {
  //         method: 'GET',
  //         headers: { accept: 'application/json' },
  //         // body: new URLSearchParams({
  //         //     action: 'Login',
  //         //     apiKey: 'KK6530499e65627bd1f85eb8d669b52cf9',
  //         //     userName: 'nhm_meghalaya',
  //         //     phoneNumber: '9127067064'
  //         // })
  //     };

  //     fetch(`https://in1-ccaas-api.ozonetel.com/cloudAgentRestAPI/index.php/CloudAgent/CloudAgentAPI/getCallLogs?
  //     user_name=${callReqObj?.user_name}&
  //     api_key=${callReqObj?.api_key}&
  //     from_date=${callReqObj?.from_date}&
  //     to_date=${callReqObj?.to_date}&
  //     campaign_name=${callReqObj?.campaign_name}&format=json`,
  //         options)
  //         .then(response => response.json())
  //         .then(response => {
  //             console.log(response, 'new data')
  //             // console.log(Object.groupBy(response.message, ({ AgentName }) => AgentName), 'newagentnow')
  //             // setCallData(response.message)
  //             // console.log(Array.isArray(response.message), 'israyy');
  //             if (Array.isArray(response.message)) {
  //                 setCallData(Object.groupBy(response.message, ({ AgentName }) => AgentName))
  //             }
  //             setLoader(false)
  //         })
  //         .catch(err => console.error(err));
  // }

  useEffect(() => {
    fetchCallRecording();
    console.log(callReqObj && callReqObj, "current date tme");
  }, []);

  const qualityAssuranceSubmitHandler = () => {
    console.log("ozone", { ...dataFromOzone });
    console.log("selected", selectedTelecaller);

    // if (!selectedTelecaller) return;

    // if (!selectedTelecaller.loginObj) {
    //   return;
    // }
    // if (selectedTelecaller.loginObj) {
    //   if (!selectTelecallerHandler(selectedTelecaller).loginObj.agentId) {
    //     return;
    //   }
    // }

    // we need to check if the scores are zero
    // CallOpening: 0,
    // Tone: 0,
    // Clarity: 0,
    // ActiveListening: 0,
    // ProcessKnowledge: 0,
    // DataIntegrity: 0,
    // these cannot be zero for any of them
    // if any of them are zero, then we need to show a toast
    // that the scores cannot be zero
    let zeroObject = {};
    Object.keys(formValue).forEach((value) => {
      if (formValue[value] === 0) {
        zeroObject[value] = true;
      }
    });

    if (Object.keys(zeroObject).length > 0) {
      toast.error("Please give a score for each of the category", {
        duration: 1331,
      });
      return;
    }

    axios
      .post(API_HOST_CRM + `/quality-assurance`, {
        data: {
          // caller: selectedTelecaller._id,
          // agentUniqueID: Number(selectedTelecaller.phone),
          // agentID: selectedTelecaller.loginObj.agentId,
          called: caseData.allocatedToUser,
          agentId: caseData.callDetails.agentID,
          agentUniqueID: caseData.callDetails.agentUniqueID,
          ucid: dataFromOzone["UCID"],
          callerID: dataFromOzone["Caller Id"],
          did: dataFromOzone["Campaign Name"].split("_")[1],
          caseId: dataFromOzone["UUI"],
          CDR: dataFromOzone,
          callOpening: formValue.CallOpening,
          callClosing: formValue.CallClosing,
          tone: formValue.Tone,
          clarity: formValue.Clarity,
          activeListening: formValue.ActiveListening,
          processKnowledge: formValue.ProcessKnowledge,
          dataIntegrity: formValue.DataIntegrity,
          redFlags: formValue.redFlags,
          feedbackToCaller: formValue.FeedbackToCaller,
        },
      })
      .then((resp) => {
        if (resp.data && resp.data.success) {
          console.log("saved qa", resp.data);
          console.log("qa saved");
          toast.success("Quality Assurance Saved");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ mt: 2, display: "flex" }}>
          <Paper
            elevation={3}
            sx={{
              height: "80vh",
              overflow: "scroll",
              width: "15%",
              padding: 2,
            }}
          >
            <Box
              sx={{
                borderBottom: "1px solid #e5efff",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px 10px 5px 10px",
              }}
            >
              <Typography variant="h5" sx={{ color: "#183b56", ml: 1 }}>
                Call Data
              </Typography>
            </Box>
            {loader ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <div>
                  <CircularProgress />
                </div>
                <Typography
                  color="#009c70"
                  sx={{ color: "#009c70", fontWeight: "bold" }}
                >
                  Loading Recordings{" "}
                </Typography>
              </Box>
            ) : callData ? (
              Object.keys(callData).map(function (key) {
                // console.log(key, callData[key], 'group by');
                return (
                  <Accordion
                    defaultExpanded={true}
                    // onClick={() => handleSidebar(callData[key])}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{
                        background: "#e5f9f3",
                        border: "1px solid #bef1e3",
                      }}
                    >
                      <Typography
                        color="success"
                        sx={{ color: "#009c70", fontWeight: "bold" }}
                      >
                        {map?.users?.[key]?.name || key}{" "}
                      </Typography>
                    </AccordionSummary>
                    {callData[key].map((k, o) => (
                      <AccordionDetails key={o} sx={{ padding: 0 }}>
                        <Chip
                          sx={{
                            color: "#fff",
                            margin: 1,
                            backgroundColor: "#F28627",
                          }}
                          // icon={<TaskAltIcon sx={{ color: '#fff' }} />}
                          label={"call to:" + k.contact}
                          onClick={() => handleSidebar(k)}
                        />
                      </AccordionDetails>
                    ))}
                  </Accordion>
                );
              })
            ) : (
              <Typography
                variant="h6"
                sx={{
                  color: "#183b56",
                  ml: 1,
                  alignContent: "center",
                  height: "100%",
                }}
              >
                No data found between
                {/* {'\n'}
                                    {callReqObj?.from_date} {'\n'} to {'\n'} {callReqObj?.to_date}  */}
              </Typography>
            )}
          </Paper>
          <Box sx={{ width: "70%", overflow: "scroll", height: "80vh" }}>
            <Box sx={{ padding: 2, display: "flex" }}>
              <ToolBar
                height={"6em"}
                name={""}
                filters={[
                  {
                    field: {
                      name: "telecaller",
                      type: "select",
                      multiple: true,
                      option: {
                        key: "TelecallersTo",
                        value: "_id",
                        label: "name",
                      },
                      label: "Caller",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    data: {
                      TelecallersTo: [
                        // {
                        //   _id: "Any",
                        //   name: "Any",
                        // },
                        ...(users || []).filter((u) => {
                          return u.roles.includes(
                            process.env.REACT_APP_TELECALLER
                          );
                        }),
                      ],
                    },
                    state: filter,
                  },
                  {
                    field: {
                      name: "contact",
                      type: "text",
                      label: "Contact",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                  {
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    field: {
                      name: "motherId",
                      type: "text",
                      label: "Mother ID",
                    },
                    state: filter,
                  },
                  {
                    field: {
                      name: "from",
                      type: "date",
                      label: "From Date",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                  {
                    field: {
                      name: "to",
                      type: "date",
                      label: "To Date",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                  // {

                  //     field: {
                  //         name: "From Date & Time",
                  //         type: "DateTime",
                  //         label: "From Date & Time",
                  //     },
                  //     onChange: (name, value) => {
                  //         // const { $D, $H, $L, $M, $W, $m, $ms, $s, $u, $x, $y, $d } = name
                  //         // console.log(('0' + (name.$M < 10 ? name.$M + 1 : name.$M)), 'length count2');
                  //         console.log(name && name.$y + '-'
                  //             + (name.$M < 10 ? ('0' + (name.$M + 1)) : name.$M)
                  //             + '-' + (name.$D < 10 ? ('0' + name.$D) : name.$D)
                  //             + ' ' + (name.$H < 10 ? ('0' + name.$H) : name.$H)
                  //             + ':' + (name.$m < 10 ? ('0' + name.$m) : name.$m)
                  //             + ':' + (name.$s < 10 ? ('0' + name.$s) : name.$s), 'from date');
                  //         // setCallReqObj({
                  //         //     ...callReqObj,
                  //         //     from_date: `{${y}-${M}-${D}%20${H}:${m}:${s}}`
                  //         // })
                  //         setCallReqObj({
                  //             ...callReqObj,
                  //             // from_date: name && name.$y + '-' + (name.$M.length < 2 ? '0' + name.$M + 1 : name.$M) + '-' + (name.$D) + ' ' + (name.$H) + ':' + (name.$m) + ':' + (name.$m)
                  //             from_date:
                  //                 name && name.$y + '-'
                  //                 + (name.$M < 10 ? ('0' + (name.$M + 1)) : name.$M)
                  //                 + '-' + (name.$D < 10 ? ('0' + name.$D) : name.$D)
                  //                 + ' ' + (name.$H < 10 ? ('0' + name.$H) : name.$H)
                  //                 + ':' + (name.$m < 10 ? ('0' + name.$m) : name.$m)
                  //                 + ':' + (name.$s < 10 ? ('0' + name.$s) : name.$s)
                  //         })
                  //         // setFromDate(name)
                  //     },
                  //     state: 'dsa',
                  // },
                  // {
                  //     field: {
                  //         name: "To Date & Time",
                  //         type: "DateTime",
                  //         label: "To Date & Time",
                  //     },
                  //     onChange: (name, value) => {
                  //         // console.log($y-$M-$D,$H:$m:$s,'date');
                  //         // setCallReqObj({
                  //         //     ...callReqObj,
                  //         //     to_date: $y-$M-$D $H:$m:$s
                  //         // })
                  //         setCallReqObj({
                  //             ...callReqObj,
                  //             // to_date: name && name.$y + '-' + (name.$M + 1) + '-' + (name.$D) + ' ' + (name.$H) + ':' + (name.$m) + ':' + (name.$m)
                  //             to_date: name && name.$y + '-'
                  //                 + (name.$M < 10 ? ('0' + (name.$M + 1)) : name.$M)
                  //                 + '-' + (name.$D < 10 ? ('0' + name.$D) : name.$D)
                  //                 + ' ' + (name.$H < 10 ? ('0' + name.$H) : name.$H)
                  //                 + ':' + (name.$m < 10 ? ('0' + name.$m) : name.$m)
                  //                 + ':' + (name.$s < 10 ? ('0' + name.$s) : name.$s)
                  //         })
                  //         // setToDate(name)
                  //         // setFilter({ ...filter });
                  //     },
                  //     state: 'dsa',
                  // },
                ]}
                // buttons={[
                //     {
                //         name: 'getRecordings',
                //         onClick: () => fetchCallRecording(),
                //         // type : 'button',
                //         // icon,
                //         // disable : false
                //     }
                // ]}
              />
              <Box>
                <Button
                  sx={{ whiteSpace: "nowrap", margin: 2 }}
                  // size='small'
                  variant="contained"
                  onClick={() => fetchCallRecording()}
                >
                  Get Calls
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid #e5efff",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px 10px 5px 10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: "95%",
                    border: "1px solid #e5efff",
                    pb: 5,
                    height: "auto",
                  }}
                >
                  <Box
                    sx={{
                      borderBottom: "1px solid #e5efff",
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px 10px 5px 10px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        minWidth: "100%",
                      }}
                    >
                      <Typography variant="h5" sx={{ color: "#375674" }}>
                        {" "}
                        Quality Assessment
                      </Typography>
                    </Box>
                  </Box>
                  {agent && (
                    <Box sx={{ padding: 2 }}>
                      {/* <Typography variant='h5' sx={{ color: '#375674' }}>Agent Name {'\n'} {agent?.AgentName}d</Typography> */}

                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        <div className="col-md-4">
                          <Box sx={{ padding: 1 }}>
                            <Typography
                              variant="p"
                              sx={{ color: "#577592", fontSize: "1em" }}
                            >
                              Name :
                              <span
                                style={{
                                  color: "#375674",
                                  fontSize: "1em",
                                  fontWeight: "bold",
                                }}
                              >
                                {agent?.name}
                              </span>
                            </Typography>
                          </Box>
                        </div>
                        <div className="col-md-4">
                          <Box sx={{ padding: 1 }}>
                            <Typography
                              variant="p"
                              sx={{ color: "#577592", fontSize: "1em" }}
                            >
                              Agent Ph. Number :
                              <span
                                style={{
                                  color: "#375674",
                                  fontSize: "1em",
                                  fontWeight: "bold",
                                }}
                              >
                                {agent?.phone}
                              </span>
                            </Typography>
                          </Box>
                        </div>
                        <div className="col-md-4">
                          <Box sx={{ padding: 1 }}>
                            <Typography
                              variant="p"
                              sx={{ color: "#577592", fontSize: "1em" }}
                            >
                              Agent Status :
                              <span
                                style={{
                                  color: "#375674",
                                  fontSize: "1em",
                                  fontWeight: "bold",
                                }}
                              >
                                {agent?.status}
                              </span>
                            </Typography>
                          </Box>
                        </div>
                        <div className="col-md-4">
                          <Box sx={{ padding: 1 }}>
                            <Typography
                              variant="p"
                              sx={{ color: "#577592", fontSize: "1em" }}
                            >
                              CallDuration :
                              <span
                                style={{
                                  color: "#375674",
                                  fontSize: "1em",
                                  fontWeight: "bold",
                                }}
                              >
                                {callRecording?.Duration}
                              </span>
                            </Typography>
                          </Box>
                        </div>
                        <div className="col-md-4">
                          <Box sx={{ padding: 1 }}>
                            <Typography
                              variant="p"
                              sx={{ color: "#577592", fontSize: "1em" }}
                            >
                              Recording :
                              {callRecording?.["Audio Download"] ? (
                                <audio id="player" controls>
                                  <source
                                    src={callRecording?.["Audio Download"]}
                                    type="audio/mp3"
                                  />
                                </audio>
                              ) : (
                                "No Recording"
                              )}
                            </Typography>
                          </Box>
                        </div>

                        <div className="col-md-4">
                          <Box sx={{ padding: 1 }}>
                            <Typography
                              variant="p"
                              sx={{ color: "#577592", fontSize: "1em" }}
                            >
                              Call Date :
                              <span
                                style={{
                                  color: "#375674",
                                  fontSize: "1em",
                                  fontWeight: "bold",
                                }}
                              >
                                {caseData?.callDate
                                  ? dayjs(caseData?.callDate).format(
                                      "DD/MM/YYYY"
                                    )
                                  : ""}
                              </span>
                            </Typography>
                          </Box>
                        </div>
                        {/* {
                                                callData && callData &&
                                                Object.keys(callData).forEach(function (key) {
                                                    console.log(key, callData[key], 'group by');
                                                    callData[key].map((item, index) => (
                                                        < Chip
                                                            key={index}
                                                            sx={{ color: '#fff', margin: 1, backgroundColor: '#F28627' }}
                                                            icon={<TaskAltIcon sx={{ color: '#fff' }} />}
                                                            label={item?.AudioFile}
                                                        />
                                                    ))
                                                })
                                            } */}
                        {/* {
                                                agent?.map((k, o) => (
                                                    // < Chip
                                                    // key={o}
                                                    // sx={{ color: '#fff', margin: 1, backgroundColor: '#F28627' }}
                                                    // icon={<TaskAltIcon sx={{ color: '#fff' }} />}
                                                    // label={k.recordingOne}
                                                    // // onClick={(e) => {
                                                    //     //     console.log(r, 'click value');
                                                    //     //     handleSingleFromGroup(r)
                                                    //     // }}
                                                    //     />
                                                    // <audio key={o} src="k?.AudioFile" controls autoPlay /> */}

                        {/* ))
                                            } */}
                      </Box>
                    </Box>
                  )}
                  <Box
                    sx={{
                      borderBottom: "1px solid #e5efff",
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px 10px 5px 10px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{ textAlign: "center", color: "#375674" }}
                      >
                        {" "}
                        UCID: {callRecording?.UCID || ""}
                      </Typography>
                    </Box>
                    {/* Commented out beacause i don't why it was there */}
                    {/* <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Chip
                        sx={{
                          color: "#ffbb00",
                          borderColor: "#ffbb00",
                          [`& .${chipClasses.icon}`]: {
                            color: "#ffbb00",
                          },
                        }}
                        icon={<PendingIcon />}
                        label="Upcoming"
                        variant="outlined"
                      />

                      <Chip
                        sx={{
                          color: "#00c48c",
                          borderColor: "#00c48c",
                          [`& .${chipClasses.icon}`]: {
                            color: "#00c48c",
                          },
                        }}
                        icon={<CheckCircleIcon />}
                        label="Ongoing"
                        variant="outlined"
                      />

                      <Chip
                        sx={{
                          color: "#0265ff",
                          borderColor: "#0265ff",
                          [`& .${chipClasses.icon}`]: {
                            color: "#0265ff",
                          },
                        }}
                        icon={<DoneAllIcon />}
                        label={"Call Done"}
                        variant="outlined"
                      />
                    </Box> */}
                    {/* Commented out bcause i don't why it was there */}
                  </Box>
                  <div className="m-2 p-2">
                    <div className="row ">
                      <div className="col-md-6 p-1">
                        <Box sx={{ padding: 1, border: ".5px solid grey" }}>
                          <Typography
                            variant="p"
                            sx={{ color: "#577592", fontSize: ".8em" }}
                          >
                            Name:
                            <span
                              style={{
                                color: "#375674",
                                fontSize: "1.2em",
                                fontWeight: "bold",
                              }}
                            >
                              {caseData?.name}{" "}
                            </span>
                          </Typography>
                        </Box>
                      </div>
                      <div className="col-md-6 p-1">
                        <Box sx={{ padding: 1, border: ".5px solid grey" }}>
                          <Typography
                            variant="p"
                            sx={{ color: "#577592", fontSize: ".8em" }}
                          >
                            District:
                            <span
                              style={{
                                color: "#375674",
                                fontSize: "1.2em",
                                fontWeight: "bold",
                              }}
                            >
                              {caseData?.districtName}
                            </span>{" "}
                          </Typography>
                        </Box>
                      </div>
                      <div className="col-md-6 p-1">
                        <Box sx={{ padding: 1, border: ".5px solid grey" }}>
                          <Typography
                            variant="p"
                            sx={{ color: "#577592", fontSize: ".8em" }}
                          >
                            Contact:
                            <span
                              style={{
                                color: "#375674",
                                fontSize: "1.2em",
                                fontWeight: "bold",
                              }}
                            >
                              {caseData?.contact}
                            </span>
                          </Typography>
                        </Box>
                      </div>
                      <div className="col-md-6 p-1">
                        <Box sx={{ padding: 1, border: ".5px solid grey" }}>
                          <Typography
                            variant="p"
                            sx={{ color: "#577592", fontSize: ".8em" }}
                          >
                            Call status:
                            <span
                              style={{
                                color: "#375674",
                                fontSize: "1.2em",
                                fontWeight: "bold",
                              }}
                            >
                              {caseData?.status}
                            </span>
                          </Typography>
                        </Box>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 10px 5px 10px",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{ ml: 2, textAlign: "center", color: "#375674" }}
                      >
                        {" "}
                        Quality Assurance Form
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{ ml: 2, textAlign: "center", color: "#375674" }}
                      >
                        {" "}
                        Score {scoreCalculate}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        borderBottom: "1px solid #e5efff",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 10px 5px 10px",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      {<></>}
                      <Grid
                        container
                        spacing={1}
                        sx={{
                          width: "100%",
                        }}
                      >
                        <Grid item xs={12} sm={12} md={6}>
                          <SelectA
                            field={{
                              type: "select",
                              label: "Call Opening",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "CallOpening",
                            }}
                            sxx={{ width: "100%" }}
                            defaultValue={0}
                            // disabled={!!uploaded}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Call Opening",
                                },
                                {
                                  _id: 1,
                                  name: 1,
                                },
                                {
                                  _id: 2,
                                  name: 2,
                                },
                                {
                                  _id: 3,
                                  name: 3,
                                },
                                {
                                  _id: 4,
                                  name: 4,
                                },
                                {
                                  _id: 5,
                                  name: 5,
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name", value);
                              setFormValue({
                                ...formValue,
                                CallOpening: value,
                              });
                            }}
                            value={formValue.CallOpening}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                          {/* Call Closing */}
                          <SelectA
                            field={{
                              type: "select",
                              label: "Call Closing",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "CallClosing",
                            }}
                            sxx={{ width: "100%" }}
                            defaultValue={0}
                            // disabled={!!uploaded}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Call Closing",
                                },
                                {
                                  _id: 1,
                                  name: 1,
                                },
                                {
                                  _id: 2,
                                  name: 2,
                                },
                                {
                                  _id: 3,
                                  name: 3,
                                },
                                {
                                  _id: 4,
                                  name: 4,
                                },
                                {
                                  _id: 5,
                                  name: 5,
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name", value);
                              setFormValue({
                                ...formValue,
                                CallClosing: value,
                              });
                            }}
                            value={formValue.CallClosing}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <SelectA
                            field={{
                              type: "select",
                              label: "Tone",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "Tone",
                            }}
                            defaultValue={0}
                            disabled={qaFromBackend && qaFromBackend.tone}
                            sxx={{ width: "100%" }}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Tone",
                                },
                                {
                                  _id: 1,
                                  name: "Options Needs Improvement",
                                },
                                {
                                  _id: 2,
                                  name: "Below Average",
                                },
                                {
                                  _id: 3,
                                  name: "Meets Expectation",
                                },
                                {
                                  _id: 4,
                                  name: "Exceeds Expectation",
                                },
                                {
                                  _id: 5,
                                  name: "Outstanding",
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name");
                              setFormValue({
                                ...formValue,
                                Tone: value,
                              });
                            }}
                            value={formValue.Tone}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                          <SelectA
                            field={{
                              type: "select",
                              label: "Clarity",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "Clarity",
                            }}
                            defaultValue={0}
                            // disabled={!!uploaded}
                            sxx={{ width: "100%" }}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Clarity",
                                },
                                {
                                  _id: 1,
                                  name: "Options Needs Improvement",
                                },
                                {
                                  _id: 2,
                                  name: "Below Average",
                                },
                                {
                                  _id: 3,
                                  name: "Meets Expectation",
                                },
                                {
                                  _id: 4,
                                  name: "Exceeds Expectation",
                                },
                                {
                                  _id: 5,
                                  name: "Outstanding",
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name");
                              setFormValue({
                                ...formValue,
                                Clarity: value,
                              });
                            }}
                            value={formValue.Clarity}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <SelectA
                            field={{
                              type: "select",
                              label: "Active Listening",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "ActiveListening",
                            }}
                            defaultValue={0}
                            // disabled={!!uploaded}
                            sxx={{ width: "100%" }}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Active Listening",
                                },
                                {
                                  _id: 1,
                                  name: "Options Needs Improvement",
                                },
                                {
                                  _id: 2,
                                  name: "Below Average",
                                },
                                {
                                  _id: 3,
                                  name: "Meets Expectation",
                                },
                                {
                                  _id: 4,
                                  name: "Exceeds Expectation",
                                },
                                {
                                  _id: 5,
                                  name: "Outstanding",
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name");
                              setFormValue({
                                ...formValue,
                                ActiveListening: value,
                              });
                            }}
                            value={formValue.ActiveListening}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <SelectA
                            field={{
                              type: "select",
                              label: "Process Knowledge",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "ProcessKnowledge",
                            }}
                            defaultValue={0}
                            // disabled={!!uploaded}
                            sxx={{ width: "100%" }}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Process Knowledge",
                                },
                                {
                                  _id: 1,
                                  name: "Options Needs Improvement",
                                },
                                {
                                  _id: 2,
                                  name: "Below Average",
                                },
                                {
                                  _id: 3,
                                  name: "Meets Expectation",
                                },
                                {
                                  _id: 4,
                                  name: "Exceeds Expectation",
                                },
                                {
                                  _id: 5,
                                  name: "Outstanding",
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name");
                              setFormValue({
                                ...formValue,
                                ProcessKnowledge: value,
                              });
                            }}
                            value={formValue.ProcessKnowledge}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <SelectA
                            field={{
                              type: "select",
                              label: "Data Integrity",
                              option: {
                                key: "Types",
                                value: "_id",
                                label: "name",
                              },
                              name: "DataIntegrity",
                            }}
                            defaultValue={0}
                            // disabled={!!uploaded}
                            sxx={{ width: "100%" }}
                            data={{
                              Types: [
                                {
                                  _id: 0,
                                  name: "Select Data Integrity",
                                },
                                {
                                  _id: 1,
                                  name: "Options Needs Improvement",
                                },
                                {
                                  _id: 2,
                                  name: "Below Average",
                                },
                                {
                                  _id: 3,
                                  name: "Meets Expectation",
                                },
                                {
                                  _id: 4,
                                  name: "Exceeds Expectation",
                                },
                                {
                                  _id: 5,
                                  name: "Outstanding",
                                },
                              ],
                            }}
                            onChange={(name, value, multiple) => {
                              console.log(name, "name");
                              setFormValue({
                                ...formValue,
                                DataIntegrity: value,
                              });
                            }}
                            value={String(formValue.DataIntegrity)}
                          />
                        </Grid>
                      </Grid>

                      {/* <FieldA field={[{
                                                field: {
                                                    name: "from",
                                                    type: "date",
                                                    label: "Assign From",
                                                },
                                                onChange: (name, value) => {
                                                    filter[name] = value;
                                                    setFilter({ ...filter });
                                                },
                                                state: 'filter',
                                            },]} data={'data'}
                                                // onChange={onChange}
                                                // state={state}
                                                sxx={{ m: 0 }} /> */}
                      <FormControl sx={{ width: "47%" }}>
                        <TextField
                          id="outlined-basic"
                          label="Red Flags"
                          variant="outlined"
                          value={formValue.redFlags}
                          onChange={(e) => {
                            setFormValue({
                              ...formValue,
                              redFlags: e.target.value,
                            });
                          }}
                        />
                      </FormControl>
                      <FormControl sx={{ width: "47%" }}>
                        <TextField
                          id="outlined-basic"
                          label="Feedback to caller"
                          variant="outlined"
                          value={formValue.FeedbackToCaller}
                          onChange={(e) => {
                            setFormValue({
                              ...formValue,
                              FeedbackToCaller: e.target.value,
                            });
                          }}
                        />
                      </FormControl>

                      <Stack
                        direction={"column"}
                        alignItems={"center"}
                        columnGap={"0.5rem"}
                        rowGap={"0.5rem"}
                        minWidth={"100%"}
                      >
                        {
                          // if dataFromOzone exists then
                          // dataFromOzone && (
                          //   <Box>
                          //     <PopoverSearch
                          //       dataFromOzone={dataFromOzone}
                          //       title={"Telecallers"}
                          //       onSelect={selectTelecallerHandler}
                          //     />
                          //   </Box>
                          // )
                        }

                        {dataFromOzone && selectedTelecaller && (
                          <></>
                          // <Box
                          //   sx={{
                          //     display: "flex",
                          //     alignItems: "center",
                          //     padding: "0.3rem",
                          //     paddingLeft: "0.5rem",
                          //     paddingRight: "0.5rem",
                          //     borderStyle: "solid",
                          //     borderWidth: "0.2rem",
                          //     borderRadius: "0.4rem",
                          //     borderColor: "black",
                          //   }}
                          // >
                          //   <Box>{selectedTelecaller.name}</Box>
                          //   <Box>
                          //     <IconButton
                          //       onClick={() => {
                          //         setSelectedTelecaller(null);
                          //       }}
                          //     >
                          //       <CancelIcon />
                          //     </IconButton>
                          //   </Box>
                          // </Box>
                        )}
                        <QualityAssuranceToolTipButton
                          dataFromOzone={dataFromOzone}
                          selectedTelecaller={true}
                          onClick={() => {
                            qualityAssuranceSubmitHandler();
                          }}
                        />
                      </Stack>
                      {/* dataFromOzone && (
                        <Box
                          sx={{
                            minWidth: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            rowGap: "1rem",
                          }}
                        >
                          {isQAExists ? null : (
                            <>
                              <Box>
                                <PopoverSearch
                                  dataFromOzone={dataFromOzone}
                                  title={"Telecallers"}
                                  onSelect={selectTelecallerHandler}
                                />
                              </Box>
                              {
                                
                                selectedTelecaller && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "0.3rem",
                                      paddingLeft: "0.5rem",
                                      paddingRight: "0.5rem",
                                      borderStyle: "solid",
                                      borderWidth: "0.2rem",
                                      borderRadius: "0.4rem",
                                      borderColor: "black",
                                    }}
                                  >
                             
                                    <Box>
                                      <IconButton
                                        onClick={() => {
                                          setSelectedTelecaller(null);
                                        }}
                                      >
                                        <CancelIcon />
                                      </IconButton>
                                    </Box>
                                  </Box>
                                )
                              }

                         
                            </>
                          )}
                        </Box>
                      ) */}
                    </Box>
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

/**
 * A button binded closedly to quality assurance
 *
 * So this button will check two things
 * - dataFromOzone exists
 * - selectedTelecaller exists
 *
 *
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {Function} props.onClick
 * @param {boolean} props.disabled
 * @param {object} props.dataFromOzone
 * @param {object} props.selectedTelecaller
 */
const QualityAssuranceToolTipButton = (props) => {
  const { dataFromOzone, selectedTelecaller, onClick } = props;

  // checking if dataFromOzone and selected Telecaller both exists
  // then we don't need to disable it and no tooltip necessary

  if (dataFromOzone && selectedTelecaller) {
    return (
      <Button
        variant="contained"
        sx={{
          width: "50%",
          textAlign: "center",
          margin: "auto",
        }}
        onClick={onClick}
      >
        Submit
      </Button>
    );
  }

  // so we first check if dataFromOzone exists
  // we show a tooltip indidicating that user needs to click on
  // a call from left side or that ozone tell data don't exists
  if (!dataFromOzone) {
    return (
      <Tooltip
        placement="top"
        arrow
        title={
          <h3 style={{ fontSize: "1.1rem" }}>
            The button is disabled. Click on a call from sidebar or ozone tell
            data doesn't exists for the call.
          </h3>
        }
      >
        <span
          style={{
            minWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: "50%",
              textAlign: "center",
              margin: "auto",
            }}
            onClick={() => {}}
            disabled={true}
          >
            Submit
          </Button>
        </span>
      </Tooltip>
    );
  }

  if (dataFromOzone && !selectedTelecaller) {
    return (
      <Tooltip
        placement="top"
        arrow
        title={
          <h3 style={{ fontSize: "1.1rem" }}>
            Please select a telecaller by clicking on the telecaller button and
            searching for the telecaller
          </h3>
        }
      >
        <span>
          <Button
            variant="contained"
            sx={{
              width: "50%",
              textAlign: "center",
              margin: "auto",
            }}
            onClick={() => {}}
            disabled={true}
          >
            Submit
          </Button>
        </span>
      </Tooltip>
    );
  }

  return <Tooltip></Tooltip>;
};

export default QualityAssurance;
